<script>
import {defineComponent} from "vue";
import {useLandingPageStore} from "../../stores/landingPage";

import {useDonationSessionStore} from "../../stores/donationSession";
import Icon from "../components/Icon.vue";
import DonationInput from "../donation/DonationInput.vue";
import {useAnalyticEventStore} from "../../stores/analyticEvents";
import {ApplicationHelper} from "../../helpers/ApplicationHelper";

export default defineComponent({
  name: "DonorWall",
  components: {
    DonationInput,
    Icon,
  },
  props: {
    donationData: {
      type: Object,
      required: false
    }
  },
  setup() {
    const landingStore = useLandingPageStore();
    const sessionStore = useDonationSessionStore();
    const analyticEventStore = useAnalyticEventStore();

    return {
      landingStore,
      sessionStore,
      analyticEventStore,
    };
  },
  data() {
    return {

    };
  },
  computed: {
    ApplicationHelper() {
      return ApplicationHelper;
    }

  },
  watch: {

  },

  async mounted() {
  },

  methods: {

  }
});

</script>

<template>
  <div class="donor-wall-container">
    <div class="caption-bold mb-2">
      Latest Gifts
    </div>

    <div>
      <div
        v-if="donationData"
        class="donor-wall-list"
      >
        <div
          v-for="donation in donationData"
          class="donor-wall-item"
        >
          <div class="icon-container">
            <icon icon="hand-heart" />
          </div>

          <div class="donation-details-container w-full">
            <div class="donor-name">
              {{ donation.name }}
            </div>
            <div class="flex flex-row align-bottom justify-between">
              <div class="donation-date mt-auto">
                {{ ApplicationHelper.formatDate(donation.date, { time: false, year: false, weekday: false}) }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="donationData.length === 0"
          class="no-donations donor-wall-item"
        >
          <div class="icon-container">
            <icon icon="hand-heart" />
          </div>
          <div>There are no gifts yet, be the first!</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.donor-wall-container {
  background-color: white;
  padding: $space-lg;
  border-radius: $radius-rounded;
  box-shadow: $shadow-card;

  .donor-wall-list {
    @apply flex flex-col gap-4;
  }
  .donor-wall-item {
    @apply flex flex-row;
  }

  .icon-container {
    @apply mr-4 h-10 w-10 min-w-10 flex justify-center items-center mt-1;
    border-radius: 200px;
    border:2px solid var(--color-primary--dark);
    background-color: $color-section-bg;
    //background-color: #F3F2F2;
    :deep(.icon) svg path {
      fill: var(--color-primary--dark);
    }
  }

  .donation-details-container {
    @apply flex flex-col;
    .donor-name {
      @apply font-semibold;
    }
    .donation-amount {
      @apply mr-4;
    }
  }

  .no-donations {
    @apply text-center py-4 text-gray-500 font-semibold p-4;
    @apply bg-green-200 border-green-600 border-2 rounded-md;
  }


}


</style>
